<template>
    <div class="video_config chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">频道</span>
            <el-select v-model="config.url" placeholder="请选择频道"
                       :popper-append-to-body="false" @change="getRender" @>
                <el-option
                        v-for="item in urlList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
      <div class="chartDivConfig selViewConfig">
        <span class="span_til">协议</span>
        <el-select v-model="config.agreement" placeholder="请选择协议"
                   :popper-append-to-body="false" @change="getRender" @>
          <el-option
              v-for="item in agreementLsit"
              :key="item.value"
              :label="item.name"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
        <div class="chartDivConfig textViewConfig">
            <span class="span_til">自定频道</span>
            <el-input
                    class="inline-input"
                    type="textarea"
                    autosize
                    size="mini"
                    placeholder="再此输入频道地址！"
                    v-model="config.url"
                    @change="getRender">
            </el-input>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">透明度</span>
            <el-input v-model="config.opacity" @change="getRender" type="number"></el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'video_config',
        components: {},
        data() {
            return {
                restaurants: [],
                urlList:[
                    {name:'CCTV-1',value:'http://ivi.bupt.edu.cn/hls/cctv1hd.m3u8'},
                    {name:'CCTV-3',value:'http://ivi.bupt.edu.cn/hls/cctv3hd.m3u8'},
                    {name:'CCTV-5',value:'http://ivi.bupt.edu.cn/hls/cctv5hd.m3u8'},
                    {name:'CCTV-6',value:'http://ivi.bupt.edu.cn/hls/cctv6hd.m3u8'},
                    {name:'香港卫视',value:'rtmp://live.hkstv.hk.lxdns.com/live/hks'},
                    {name:'湖南卫视',value:'rtmp://58.200.131.2:1935/livetv/hunantv'},
                ],
              agreementLsit:[
                   {name:'http',value:'http'},
                   {name:'rtmp(rtmp仅支持flash支持版本的浏览器)',value:'rtmp'},
              ]
            }
        },
        computed: {
            config() {
                return this.$store.state.designer.chart.setting.params;
            },
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },
        },
        mounted() {
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .video_config {

    }
</style>
